const easing = {
    default: "cubic-bezier(0.3, 0.3, 0.2, 1)",
} as const;

const animation = {
    default: `200ms ${easing.default}`,
} as const;

export const motion = {
    easing: { ...easing },
    animation: { ...animation },
} as const;
